<template>
	<div class="skeleton-rows" aria-busy="true">
		<div v-for="index in rows" :key="index" class="row">
			<span class="bar label"></span>
			<span class="bar value"></span>
		</div>
	</div>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		rows?: number
	}>(),
	{ rows: 6 }
)
</script>

<style scoped>
@keyframes pulse {
	50% {
		opacity: 0.5;
	}
}

.skeleton-rows {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-sm);

	.row {
		display: flex;
		justify-content: space-between;
		padding: 6px 0;
	}

	.bar {
		height: var(--spacing-sm);
		border-radius: var(--border-radius-sm);
		background: var(--neutral-200);
		animation: pulse 1.5s ease-in-out infinite;

		&.label {
			width: 35%;
		}

		&.value {
			width: 25%;
		}
	}
}
</style>
